import React from 'react';
import { Button } from '@biq/apex-ui';
import { Grid, SxProps } from '@mui/material';

interface EditDrawerFooterProps {
    mainContainerStyles: SxProps;
    onDeleteClick: () => void;
    onSubmitClick: () => void;
}

export const EditDrawerFooter = ({
    mainContainerStyles,
    onDeleteClick,
    onSubmitClick,
}: EditDrawerFooterProps): React.JSX.Element => {
    return (
        <Grid sx={mainContainerStyles}>
            <Button
                size='large'
                variant='text'
                color='error'
                onClick={onDeleteClick}
            >
                Remove
            </Button>
            <Button size='large' color='primary' onClick={onSubmitClick}>
                Update
            </Button>
        </Grid>
    );
};
